import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { LicenseStateService } from '../services/license-state-service/license-state-service';
import { isLicenseRefusal } from '../models/problem-detail.model';

/**
 * Turns the three license refusals (`SCHOOL_LICENSE_INACTIVE`, `LICENSE_TIER_INSUFFICIENT`,
 * `AI_QUOTA_EXCEEDED`) into one explanation shown once, wherever in the application the request
 * came from. The error is re-thrown, so each service still runs its own cleanup, but its generic
 * message cannot overwrite this one (see `NotificationService.showBlockingError`).
 *
 * Sees errors after `problemDetailInterceptor` (listed last, so innermost), so the code is readable
 * even on an export's Blob response.
 *
 * The service is resolved lazily: it depends on `SchoolService`, which depends on `HttpClient`,
 * and injecting that chain while the interceptor chain is being built would be circular.
 */
export const licenseInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && isLicenseRefusal(error)) {
        injector.get(LicenseStateService).handleLicenseError(error);
      }
      return throwError(() => error);
    }),
  );
};
